import * as Configuration from '../../../app.constants.js';

AddAccountGMBController.$inject = ['$scope', '$state', '$stateParams', '$http', 'company', 'AlertingFactory', 'TopToolbarFactory', 'AccountsFactory'];
export function AddAccountGMBController($scope, $state, $stateParams, $http, company, AlertingFactory, TopToolbarFactory, AccountsFactory) {

  $scope.goToLocations = goToLocations;
  $scope.cancel = cancel;
  $scope.isGroupAccount = isGroupAccount;

  init();

  function getData() {
    let data = {
      request_id: $stateParams.requestId || null,
      site_id: $stateParams.siteId || null,
      code: $stateParams.code || null
    };
    let url = `${Configuration.constants.baseUrl}api/1.0/companies/${company.id}/gmb/authorized/accounts`;
    
    $http.get(url, { params: data })
      .then(function success(response) {
        if (response.data.reauth) {
          window.location.href = response.data.redirect_url;
        }
        else if (response.data.error) {
          let url = response.data.redirect_url + '?error=' + response.data.reason;
          window.location.href = url;
        }
        else {
          $scope.accounts = response.data.accounts;
          $scope.locations_url = response.data.locations_url;
          $scope.isLoading = false;
          $scope.requestId = $stateParams.requestId
          $scope.selectedAccount = {
            id: "none",
            name: "none"
          }
          if ($scope.accounts.length > 0) {
            $scope.selectedAccount.id = $scope.accounts[0].id;
          }

        }
      }, function error(response) {
        AlertingFactory.alertHTTPError(response);
      });
  }

  function goToLocations() {
    $state.go("auth.alcmeon.parameters.gmb.add-account.add-locations", {
      accountId: $scope.selectedAccount.id,
      companyId: $stateParams.companyId,
      requestId: $stateParams.requestId
    });
  }

  function cancel() {
    AccountsFactory.redirectToAccountsPage($state);
  }

  function isGroupAccount(account) {
    return account.type === 'group';
  }

  function init() {
    TopToolbarFactory.setTitleTranslation('gmb/accounts/list', $scope);
    $scope.isLoading = true;

    getData();
  }
}
